// extracted by mini-css-extract-plugin
module.exports = {"block":"infoBlocks_block__2G9BZ","blockTitle":"infoBlocks_blockTitle__W7ufG","blockIcon":"infoBlocks_blockIcon__3lrtT","blockText":"infoBlocks_blockText__26RXW"};